<template>
  <v-menu open-on-hover right content-class="speed-content" :close-on-content-click="false" attach="#playBack">
    <template v-slot:activator="{ on }">
      <v-btn id="playBack" class="media-control-button hoverable media-play-back" @click.stop.prevent="" v-on="on">
        <span>{{displaySpeed}}</span>
        <span style="font-size:10px">✕</span>
      </v-btn>
    </template>

    <v-row>
      <v-col class="speed-menu">
        <v-slider
        style="z-index:2"
          ref="speedslider"
          v-model="speed"
          :value="1"
          class="speed-slider custom-slider"
          :max="2"
          :min="0.1"
          :step="0.1"
          color="#20f7c4"
          height="auto"
          @click.stop.prevent=""
          @mousedown.stop.prevent=""
        ></v-slider>
      </v-col>
    </v-row>
  </v-menu>
</template>

<script>
export default {
  props: ['defaultSpeed'],
  components: {},
  data () {
    return {
      speed: 0.1
    }
  },
  name: 'play-back-speed-button',
  watch: {
    speed (newVal) {
      let roundedNewVal = Math.round(newVal * 10) / 10;
      this.$emit('change', roundedNewVal)
    },
  },
  computed:{
    displaySpeed(){
      const me = this;
      return me.speed.toFixed(1);
    }
  },
  mounted () {
    const me = this;
    me.speed = me.defaultSpeed

    document.addEventListener('keydown', function (event) {
      const keyCode = event.which || event.keyCode || 0;
      const key = event.key;
      if((event.ctrlKey || event.metaKey )  && (keyCode === 189)){
        event.preventDefault();
        me.speed -= 0.1;
      }
      if((event.ctrlKey || event.metaKey )  && (keyCode === 187 || key === '=')){
        event.preventDefault();
        me.speed += 0.1;
      }
    })
  }
}
</script>

<style>
.speed-content {
  width: 205px;
    min-width: 205px!important;
    /* margin-left: 40px; */
    /* margin-top: 9px; */
  /* width: 205px;
      margin-left: 40px;
    margin-top: 2px; */
    overflow: hidden;
  background: transparent;
  box-shadow: none;
  border-radius: 0px;
  -webkit-box-shadow: none;
  left:40px!important;
}
.speed-content .v-slider--horizontal{
 min-height:28px!important;
}
.speed-content .row {
  margin: 0px;
}

.speed-content .col {
  padding: 0px;
}

.speed-content .col .row {
  height: 33%;
  font-size: 12px;
  color: #0062ff;
  user-select: none;
}
.speed-content .top {
  align-items: flex-start;
}
.speed-content .mid {
  padding-top: 30px;
  align-items: center;
}
.speed-content .bottom {
  align-items: flex-end;
}

.speed-content .v-input__slot{
  background: black;
}
.media-control-button.media-play-back{
  z-index:2;
}
.media-control-button.media-play-back > span{
  line-height: 20px;
}
</style>
